import Alpine from 'alpinejs';
import lottie from 'lottie-web';

document.addEventListener("alpine:init", () => {

	Alpine.data('animations', () => ({
		baseurl : '/app/themes/lincoln-arts/assets/dist/',
		type: 'json',
		el: '.lottie',
		current: null,
		segments: [
			{
				states: ['default', 'nav-open'],
				frames: [0, 15]
			},
			{
				states: ['nav-open', 'search-open'],
				frames: [15, 29]
			},
			{
				states: ['search-open', 'default'],
				frames: [31, 45]
			}
		],

		init() {

			this.anim = lottie.loadAnimation({
				container: document.querySelector(this.el),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: `${ this.baseurl }${ this.type }/data.json`,
				rendererSettings: {
					progressiveLoad: true,
				  }
			});

			this.$watch('$store.state.next', (value) => {

				const current = this.$store.state.current;
				const next = this.$store.state.next;

				const transition = this.segments.filter(item => item.states.includes(current) && item.states.includes(next));
				const frames = transition.map(item => item.frames);

				// play animation for state change
				// animation.playSegments([0, 30], true);

				if( this.$store.state.next !== 'default' ){
					this.$refs.logo.classList.add('big');
				}else{
					this.$refs.logo.classList.remove('big');
				}

				const segmentFrames = Array.from( frames[0] );

				this.anim.setDirection( this.$store.state.direction );
				this.anim.setSpeed(1.5);
				this.anim.play();
				this.anim.playSegments(
					this.$store.state.direction == 1 ? segmentFrames : segmentFrames.reverse()
					, true);
				
				

			});

			this.anim.onComplete = () => {
				// console.log( Object.assign({}, this.anim) );
				this.$store.state.current = this.$store.state.next;
				if( this.$store.state.current == 'default' ){
					
					// console.log('Animation completed');
				}
			};

		},

		playAnimation() {
			const anim = this.animations.find(item => item.event === this.current);
			const animation = lottie.loadAnimation( anim.animation );
			animation.playSegments([0, 30], true);
		}


	}));

});